import camelCase from 'lodash/camelCase';
export const HTML_DATA_BINDING_REGEX = /(\\?)(\{\{(.{0,100}?)\}\})/g;
const getPropertiesByKey = (content, propertyName) => {
    const matchingProperties = [];
    const findMatchingProperties = (element) => {
        if (typeof element !== 'object')
            return;
        if (Array.isArray(element)) {
            element.forEach((el) => findMatchingProperties(el));
            return;
        }
        Object.entries(element || {}).forEach(([key, value]) => {
            if (key === propertyName)
                matchingProperties.push(value);
            findMatchingProperties(value);
        });
    };
    findMatchingProperties(content);
    return matchingProperties;
};
/**
 * Goes through content and finds all data-bindings that have been used within a block.
 * This is needed in order to only fetch data that is used in the data binding.
 */
export const getDataSets = (content) => {
    var _a, _b;
    const result = {};
    if (!content)
        return null;
    Array.from(JSON.stringify(content).matchAll(HTML_DATA_BINDING_REGEX)).forEach((match) => {
        var _a, _b;
        const key = (_b = (_a = match[3]) === null || _a === void 0 ? void 0 : _a.split('.')) === null || _b === void 0 ? void 0 : _b[0];
        if (key)
            result[key] = true;
    });
    const bindings = getPropertiesByKey(content, 'bindings');
    // The conditions property in the Conditional component options
    const conditions = ((_b = (_a = getPropertiesByKey(content, 'component')) === null || _a === void 0 ? void 0 : _a.filter((component) => (component === null || component === void 0 ? void 0 : component.name) === 'Conditional')) === null || _b === void 0 ? void 0 : _b.map((component) => { var _a; return (_a = component === null || component === void 0 ? void 0 : component.options) === null || _a === void 0 ? void 0 : _a.conditions; })) || [];
    // regex that has a matching group for everything between "property:" and " - "
    const conditionalRegex = /property":"(.{0,100}?) - /g;
    Array.from(JSON.stringify(conditions).matchAll(conditionalRegex)).forEach((match) => {
        // The match is Title Case, so we need to convert it to camelCase
        const key = camelCase(match[1]);
        result[key] = true;
    });
    bindings.forEach((binding) => {
        Object.values(binding || {}).forEach((value) => {
            if (!value || typeof value !== 'string')
                return;
            // regular expression to match all values between 'state' and '.' excluding '.'
            Array.from(value.matchAll(/state\.(.*)\./g)).forEach((match) => {
                const key = match[1];
                if (key)
                    result[key] = true;
            });
        });
    });
    return Object.keys(result).length ? result : null;
};
//# sourceMappingURL=getDataSets.js.map